module.exports = __webpack_public_path__ + "static/img/tw.e7b0093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/tw.png
// module id = BX/F
// module chunks = 18